import login from 'pmt-modules/authRestaurant/forms/login'
import checkoutPaymentEmail from 'pmt-modules/kioskCheckout/forms/checkoutPaymentEmail'

const forms = [
  login,
  checkoutPaymentEmail,
]

export default forms
